import { render, staticRenderFns } from "./ModalBaseV3.vue?vue&type=template&id=52ae8b9d&scoped=true&"
import script from "./ModalBaseV3.vue?vue&type=script&lang=ts&"
export * from "./ModalBaseV3.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBaseV3.vue?vue&type=style&index=0&id=52ae8b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ae8b9d",
  null
  
)

export default component.exports